<template>
  <div id="app">
    <router-view :key="$route.path"></router-view>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Main',
    // all titles will be injected into this template
    titleTemplate: '%s | Potpourri',
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue